import React from 'react';
import { heroImages, whatsappLink } from '../data/mock';

export default function CTA() {
  return (
    <section className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative flex justify-center lg:justify-start">
          <div className="arch-frame w-[300px] md:w-[380px] lg:w-[420px] aspect-[3/4.2]">
            <img
              src={heroImages.cta}
              alt="Ana Rodrigues"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.4rem] leading-tight text-[color:var(--cream-100)]">
            Se fizer sentido para você,{' '}
            <span className="italic text-[color:var(--gold-400)]">vamos conversar.</span>
          </h2>
          <p className="mt-6 text-[color:var(--cream-100)]/75 text-lg leading-relaxed max-w-xl">
            Cada projeto é único. Cada resultado é construído com estratégia,
            consistência e um olhar personalizado para o seu negócio.
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center px-8 py-4 rounded-full border border-[color:var(--gold-400)]/70 text-[11px] tracking-widest-2 uppercase text-[color:var(--cream-100)] hover:bg-[color:var(--gold-500)]/15 transition-all"
          >
            Iniciar conversa no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
